import React from 'react';
import { graphql } from 'react-relay';

import withData from '@zego/lib/withData';
import PrivateHirePartnersBase from '@zego/pageContainers/gb/PrivateHirePartnersGb/PrivateHirePartnersBase';

import DidiLogo from '@zego/static/svgs/partners/didi.svg';

const HERO_SECTION_BENEFITS = [
  'Drive with our new, fairer app-based polices and save money',
  'Save time as we automatically upload your insurance certificate to your DiDi account',
  'Choose Third Party Only or Fully Comprehensive cover, either for 30 days or 1 year',
];

const DidiPrivateHireGbPage = ({ viewer }) => (
  <PrivateHirePartnersBase
    viewer={viewer}
    title="Fairer Private Hire Insurance for DiDi Drivers | Zego"
    description="Save money on private hire insurance with our fairer app-based policies.
                 Choose from Third Party Only or Fully Comprehensive cover, either for 30 days or 1 year."
    locationName="Didi Landing Page GB"
    benefits={HERO_SECTION_BENEFITS}
    logo={DidiLogo}
    logoAlt="Didi"
    logoTop={0}
    logoHeight={30}
  />
);

export default withData(DidiPrivateHireGbPage, {
  query: graphql`
    query DidiPrivateHireGbPageQuery($country: String!, $code: String!) {
      viewer {
        ...ProductCustomerService_viewer @arguments(country: $country)
        ...PrivateHireQuickEstimatesForm_viewer
        product: websiteMarketingProductByCodeAndCountryCode(
          code: $code
          countryCode: $country
        ) {
          ...ProductTheme_product
        }
        ...BaseLayout_viewer @arguments(country: $country)
      }
    }
  `,
  getVariables: () => {
    return {
      country: 'gb',
      code: 'DIDI_UK',
    };
  },
});
